import React, { useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';

import ggRouter from 'ggApp/modules/router';
import ggStore from 'ggApp/modules/store';
import ggStatic from 'ggApp/modules/static';
import { getProductById as getProductByIdAction } from 'ggApp/modules/product/actions';
import useMount from 'ggApp/shared/hooks/useMount';
import CircleLoader from 'ggApp/shared/components/CircleLoader';
import { initPartnerPage as initAction } from 'ggApp/modules/init/actions';

// export only for testing!
export const CheckoutLandingWrap = ({
    children,
    locationQuery,
    staticActions,
    getProductById,
    storeActive: { code },
    userChosenLanguage,
    init,
}) => {
    const [productLoaded, setProductLoader] = useState(false);

    useMount(() => {
        getProductById({
            productSlug: locationQuery.product_id,
            store: code,
            language: userChosenLanguage,
        }).then(() => setProductLoader(true));

        staticActions.getStaticInfo(['pdp_common']);
    });

    useMount(() => init());

    if (!productLoaded) {
        return <CircleLoader />;
    }

    return children;
};

export default connect(
    createStructuredSelector({
        storeActive: ggStore.selectors.storeActive,
        locationQuery: ggRouter.selectors.locationQuery,
        userChosenLanguage: ggStore.selectors.userChosenLanguage(),
    }),
    (dispatch) => ({
        staticActions: bindActionCreators(ggStatic.actions, dispatch),
        getProductById: bindActionCreators(getProductByIdAction, dispatch),
        init: bindActionCreators(initAction, dispatch),
    }),
)(CheckoutLandingWrap);
